import { Skeleton } from "@mui/material";
import { Wrapper } from "./styles";

function ModelContractFormSkeleton() {
  return (
    <Wrapper>
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
      <Skeleton height="28px" />
    </Wrapper>
  );
}

export default ModelContractFormSkeleton;
